import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Grid, Typography } from '@material-ui/core';
import { Divider } from '@material-ui/core';
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import { invokePostService, setReRender, handleSnackBar } from '../../../store/global/actions'

const   DeleteSimulationProfile = (props) => {

    const dispatch = useDispatch();

    const { onClose, onCompletion, element, content, type, entityId, testsuiteId} = props

    // console.log('propsnnnn------>', props)
    const [loading, setLoading] = useState(false);
    const currentUrl = window.location.href;


    const onDelete = () => {
        setLoading(true);
        dispatch(invokePostService(type === 'testcase' ? 'deleteTestcaseProfile' : 'deleteTestsuiteProfile', {testsuiteId}, [entityId, element._id]))
            .then((response) => {
                if (response.status) {
                    onCompletion('delete', 'Profile', response.message)

                } else if (response?.status == false && response?.code) {
                    onCompletion()
                }
                else {
                    dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
                }
                setLoading(false);
            })

    }


    return (
        <Grid container direction={"row"} spacing={1} >

            <Grid item xs={12}>
                <Typography> {content} </Typography>
            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", textTransform: 'capitalize' }} >
                <DeleteCancel onCancel={onClose} onDelete={onDelete} disableButton={loading} content={loading ? 'Deleting..' : 'Delete'} />
            </Grid>


        </Grid>
    )

}

export default DeleteSimulationProfile;
